import { render, staticRenderFns } from "./initiateVote.vue?vue&type=template&id=1cc579b0&scoped=true"
import script from "./initiateVote.vue?vue&type=script&lang=js"
export * from "./initiateVote.vue?vue&type=script&lang=js"
import style0 from "./initiateVote.vue?vue&type=style&index=0&id=1cc579b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc579b0",
  null
  
)

export default component.exports